import { Ng2StateDeclaration, StatesModule } from '@uirouter/angular';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { SmsListComponent } from '@fi-app/sms/sms-list/sms-list.component';
import { FiSmsEditComponent } from '@fi-app/sms/sms-edit/sms-edit.component';
import { SmsService } from '@fi-app/sms/sms.service';
import { UserService } from '@fi-app/user/user.service';
import { SmsModel } from '@fi-app/sms/sms.model';
import { SmsViewComponent } from '@fi-app/sms/sms-view/sms-view.component';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiSmsStateRootComponent } from '@fi-app/sms/sms-state-root/sms-state-root.component';
import { FiSmsCostsComponent } from '@fi-app/sms/sms-costs/sms-costs.component';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export function SmsListPageTitle(ccmPageTitle: PageTitleService) {
    ccmPageTitle.setTitleByTextId('sms_module_name');
}

const SmsState: Ng2StateDeclaration = {
    name: FiStateNames.SMS._name,
    url: '/SMS',
    abstract: true,
    component: FiSmsStateRootComponent,
};

const SmsListState: Ng2StateDeclaration = {
    name: FiStateNames.SMS.List,
    url: '/?:sortColumn&:sortDirection&:offset',
    component: SmsListComponent,
    reloadOnSearch: false,
    resolve: {
        pageTitle: [PageTitleService, SmsListPageTitle],
    },
};

export function SmsCostsPageTitle(ccmPageTitle: PageTitleService) {
    ccmPageTitle.setTitleByTextId('sms.costs_title');
}

const FiSmsCostsState = {
    name: FiStateNames.SMS.Costs,
    url: '/Costs',
    component: FiSmsCostsComponent,
    resolve: {
        pageTitle: [PageTitleService, SmsCostsPageTitle],
    },
};

export function SmsAddSms(fiSMSService: SmsService) {
    return fiSMSService.getSMSModel();
}
export function SmsAddCurrentUser(UserService: UserService, userDataService: FiUserDataService) {
    return UserService.getUserForView(userDataService.getUserId());
}
export function SmsAddPageTitle(ccmPageTitle: PageTitleService, sms: SmsModel) {
    return ccmPageTitle.setTitleByItem(sms);
}
const SmsAddState = {
    name: FiStateNames.SMS.Add,
    url: '/Add',
    views: {
        '@Module': {
            component: FiSmsEditComponent,
        },
    },
    resolve: {
        sms: [SmsService, SmsAddSms],
        currentUser: [UserService, FiUserDataService, SmsAddCurrentUser],
        pageTitle: [PageTitleService, 'sms', SmsAddPageTitle],
    },
};

export function SmsCopySms(fiSMSService: SmsService, stateService: FiStateService, transition) {
    const promise = new Promise<SmsModel>((resolve, reject) => {
        fiSMSService.getSMS(stateService.getParams(transition).Id).then(function (sms) {
            delete sms.Id;
            delete sms.SentAt;
            delete sms.SentUserName;
            resolve(sms);
        }, reject);
    });
    return promise;
}
export function SmsCopyCurrentUser(UserService: UserService, userDataService: FiUserDataService) {
    return UserService.getUserForView(userDataService.getUserId());
}
export function SmsCopyPageTitle(ccmPageTitle: PageTitleService, sms: SmsModel) {
    ccmPageTitle.setTitleByItem(sms);
}
const SmsCopyState = {
    name: FiStateNames.SMS.Copy,
    url: '/{Id:[0-9]+}/Copy',
    views: {
        '@Module': {
            component: FiSmsEditComponent,
        },
    },
    resolve: {
        sms: [SmsService, FiStateService, '$transition$', SmsCopySms],
        currentUser: [UserService, FiUserDataService, SmsCopyCurrentUser],
        pageTitle: [PageTitleService, 'sms', SmsCopyPageTitle],
    },
};

export function SmsViewSms(fiSMSService: SmsService, stateService: FiStateService, transition) {
    return fiSMSService.getSMS(stateService.getParams(transition).Id);
}
export function SmsViewPageTitle(ccmPageTitle: PageTitleService) {
    ccmPageTitle.setTitleByTextId('sms_module_name');
}
const SmsViewState = {
    name: FiStateNames.SMS.View,
    url: '/{Id:[0-9]+}',
    views: {
        '@Module': {
            component: SmsViewComponent,
        },
    },
    resolve: {
        sms: [SmsService, FiStateService, '$transition$', SmsViewSms],
        pageTitle: [PageTitleService, SmsViewPageTitle],
    },
};

export const SmsStates: StatesModule = {
    states: [SmsState, SmsListState, SmsAddState, SmsCopyState, SmsViewState, FiSmsCostsState],
};

export function registerSMSStateRules(stateAccessCheckService: StateAccessCheckService) {
    stateAccessCheckService.registerStateRules(
        [
            FiStateNames.SMS._name,
            FiStateNames.SMS.List,
            FiStateNames.SMS.Add,
            FiStateNames.SMS.Copy,
            FiStateNames.SMS.View,
        ],
        {
            SettingType: [ApplicationSettingsType.SMS],
            AccessType: AccessRightType.Share,
        },
    );

    stateAccessCheckService.registerStateRules([FiStateNames.SMS.Costs], {
        SettingType: [ApplicationSettingsType.SMS],
        AccessType: AccessRightType.Admin,
    });
}
